import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-alert-model',
  templateUrl: './alert-model.component.html',
  styleUrls: ['./alert-model.component.scss']
})
export class AlertModelComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AlertModelComponent>, @Inject(MAT_DIALOG_DATA) public message: any) { }
  public appName: string = environment.applicationName;
  ngOnInit() {
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '50px', left: '50px' });
  }
  close(): void {
    this.dialogRef.close();
  }


}
